const RCdataSegmentId = '60bddf249820642a02485773'
const RRIdataSegmentId = '61a672c6ee37ca26f22f0ce3'
const sidebarListing = [
    {
        anchorLink: '/insights',
        icon: 'icon-insights',
        menuLabel: 'Insights',
        permission: [
            'view-alerts',
            'view-activity-dashboard',
            'view-customer-statistics',
        ],
    },
    {
        anchorLink: '/customer-profiles',
        icon: 'icon-customer-profil',
        menuLabel: 'Customers',
        permission: ['view-customer-profile'],
    },
    // {
    //     anchorLink: '/register-customer',
    //     icon: 'icon-add-customer',
    //     menuLabel: 'Register Customer',
    //     permission: ['register-customer'],
    // },
    {
        anchorLink: '/configuration',
        icon: 'icon-configurations',
        menuLabel: 'Configurations',
        permission: [
            'idenfo-engine',
            'view-screening-data',
            'form-builder',
            'initiate-simulation-process',
            'branding',
            'ocr',
        ],
    },
    {
        anchorLink: '/system-users',
        icon: 'icon-system-users',
        menuLabel: 'System Users',
        permission: [
            'view-system-users',
            'manage-system-users',
            'view-roles',
            'manage-roles',
            'view-data-segments',
            'manage-data-segments',
            'view-application-access',
            'manage-application-access',
        ],
    },
    {
        anchorLink: '/system-logs',
        icon: 'icon-system-log',
        menuLabel: 'System Logs',
        permission: ['system-logs'],
    },
]

const RREDataSegment = [
    {
        anchorLink: '/insights',
        icon: 'icon-insights',
        menuLabel: 'Insights',
        permission: [
            'view-alerts',
            'view-activity-dashboard',
            'view-customer-statistics',
        ],
    },
    {
        anchorLink: '/customer-profiles',
        icon: 'icon-customer-profil',
        menuLabel: 'Customers',
        permission: ['view-customer-profile'],
    },
    {
        anchorLink: '/register-customer',
        icon: 'icon-add-customer',
        menuLabel: 'Register Customer',
        permission: ['register-customer'],
    },
    {
        anchorLink: '/configuration',
        icon: 'icon-configurations',
        menuLabel: 'Configurations',
        permission: [
            'idenfo-engine',
            'view-screening-data',
            'form-builder',
            'initiate-simulation-process',
            'branding',
            'ocr',
        ],
    },
    {
        anchorLink: '/system-users',
        icon: 'icon-system-users',
        menuLabel: 'System Users',
        permission: [
            'view-system-users',
            'manage-system-users',
            'view-roles',
            'manage-roles',
            'view-data-segments',
            'manage-data-segments',
            'view-application-access',
            'manage-application-access',
        ],
    },
    {
        anchorLink: '/system-logs',
        icon: 'icon-system-log',
        menuLabel: 'System Logs',
        permission: ['system-logs'],
    },
]
// const img2xUrl = (val) => `${val.replace(/(\.[\w\d_-]+)$/i, '@2x$1')} 2x`;

export default {
    RREDataSegment,
    RCdataSegmentId,
    RRIdataSegmentId,
    sidebarListing,
}
